import { gql } from "@apollo/client";

const RULE_FIELDS = `
  id
  name
  description
  scope
  employeeId
  employeeName
  ruleType
  period
  minOrderValue
  targetValue
  rewardCoins
  maxPerDay
  graceMinutes
  step
  tiers {
    target
    coins
  }
  startsOn
  endsOn
  isActive
  sortOrder
  summary
  timesAwarded
  coinsAwarded
`;

export const GET_REWARD_RULES = gql`
  query GetRewardRules {
    getRewardRules {
      status
      message
      rules { ${RULE_FIELDS} }
      overview {
        liveRules
        coinsThisMonth
        earnersThisMonth
        outstandingCoins
      }
    }
  }
`;

export const SAVE_REWARD_RULE = gql`
  mutation SaveRewardRule($data: RewardRuleInput!) {
    saveRewardRule(data: $data) {
      status
      message
    }
  }
`;

export const SET_REWARD_RULE_ACTIVE = gql`
  mutation SetRewardRuleActive($id: ID!, $isActive: Boolean!) {
    setRewardRuleActive(id: $id, isActive: $isActive) {
      status
      message
    }
  }
`;

export const DELETE_REWARD_RULE = gql`
  mutation DeleteRewardRule($id: ID!) {
    deleteRewardRule(id: $id) {
      status
      message
    }
  }
`;

export const GET_REWARD_LEDGER = gql`
  query GetRewardLedger($employeeId: String, $limit: Int, $offset: Int) {
    getRewardLedger(employeeId: $employeeId, limit: $limit, offset: $offset) {
      status
      message
      total
      outstandingCoins
      entries {
        id
        entryType
        coins
        title
        note
        createdAt
        employeeId
        employeeName
      }
    }
  }
`;

export const ADJUST_REWARD_COINS = gql`
  mutation AdjustRewardCoins($data: RewardAdjustInput!) {
    adjustRewardCoins(data: $data) {
      status
      message
      balance
    }
  }
`;

export const GET_EMPLOYEES = gql`
  query GetEmployeelistForRewards($data: EmployeeFilterInput) {
    getEmployeelist(data: $data) {
      status
      employee {
        id
        fullName
      }
    }
  }
`;

export const GET_GAME_RULES = gql`
  query GetGameRules {
    getGameRules {
      xp {
        perBooking
        per100Rupees
        valueCap
        fiveStar
        fourStar
      }
      levelFormula
      titles {
        code
        fromLevel
        totalXp
      }
      levels {
        level
        title
        totalXp
        xpToNext
      }
      missionsSource
      missions {
        code
        metric
        target
        xp
      }
      badges {
        code
        name
        description
        target
        unit
        scope
        minRatings
      }
      eotm {
        value
        rating
        punctuality
        steps
        perDeduction
        onTimeMinutes
        minBookings
      }
    }
  }
`;

const EOTM_POINTS = `
  value
  rating
  punctuality
  steps
  deductions
`;

const EOTM_WINNER = `
  month
  employeeId
  name
  score
  prizeCoins
  note
  announcedAt
  breakdown {
    rank
    bookings
    revenue
    avgRating
    onTimePct
    stepsPct
    deductions
    points { ${EOTM_POINTS} }
  }
`;

export const GET_EOTM_MONTH = gql`
  query GetEotmMonth($month: String!) {
    getEotmMonth(month: $month) {
      month
      minBookings
      isClosed
      winner { ${EOTM_WINNER} }
      candidates {
        rank
        employeeId
        name
        bookings
        revenue
        avgRating
        rated
        onTimePct
        stepsPct
        deductions
        score
        eligible
        points { ${EOTM_POINTS} }
      }
    }
  }
`;

export const GET_EOTM_HISTORY = gql`
  query GetEotmHistory {
    getEotmHistory { ${EOTM_WINNER} }
  }
`;

export const ANNOUNCE_EOTM = gql`
  mutation AnnounceEotm($data: EotmAnnounceInput!) {
    announceEotm(data: $data) {
      status
      message
    }
  }
`;
